module.exports = __webpack_public_path__ + "static/img/wxtci.69e2e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxtci.png
// module id = k4xo
// module chunks = 1